import { getInitData, isInsideTelegram } from "./telegram";

/**
 * Desktop site sign-in (Telegram Login Widget). Inside Telegram nothing here is
 * used: requests keep sending the signed initData exactly as before.
 */
const TOKEN_KEY = "kms.webSession";
const PROFILE_KEY = "kms.webProfile";

export interface WebProfile {
  firstName: string | null;
  username: string | null;
  photoUrl?: string | null;
}

const read = (k: string): string => {
  try {
    return localStorage.getItem(k) ?? "";
  } catch {
    return "";
  }
};

export const getWebSession = (): string => (isInsideTelegram() ? "" : read(TOKEN_KEY));

export function getWebProfile(): WebProfile | null {
  const raw = read(PROFILE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as WebProfile;
  } catch {
    return null;
  }
}

export function setWebSession(token: string, profile: WebProfile): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
  } catch {
    /* private mode: the session simply won't persist */
  }
}

export function clearWebSession(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(PROFILE_KEY);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event("kms:signed-out"));
}

/** Auth headers for every API call: initData in Telegram, the web session in a browser. */
export function authHeaders(): Record<string, string> {
  if (isInsideTelegram()) return { "X-Telegram-Init-Data": getInitData() };
  const token = getWebSession();
  return token ? { "X-Web-Session": token } : { "X-Telegram-Init-Data": getInitData() };
}
